module.exports = __webpack_public_path__ + "img/file-icon.13c1917f.svg";